import ctl from '@netlify/classnames-template-literals';

const rowStyles = ctl(`
    border-t-chinese-silver 
    border-t-[1px] 
    text-sm hover:bg-ghost-white 
    transition-colors
    cursor-pointer
  `);

export default {
  rowStyles,
};
